/**
 * 获取siteid
 * @param {string} str
 * @returns {string}
 */
export function getSiteId(str) {
  const url = window.location.href
  let siteId = ''
  if (url && url.split(str)[1]) {
    const urlSite = url.split(str)[1]
    if (urlSite.split('/').length > 0) {
      siteId = urlSite.split('/')[0]
    } else {
      siteId = urlSite
    }
  }
  return siteId
}

/**
 * 存储
 * @param {*} o get / set / remove
 * @param {*} k 属性
 * @param {*} v 值
 */
export function setStorage (o, k, v) {
  if (!k || !o) return false

  const l = window.sessionStorage

  if (o === 'get') {
    return l.getItem(k)
  }

  if (o === 'set') {
    l.setItem(k, v)
  }

  if (o === 'remove') {
    l.removeItem(k)
  }
}

/**
 * 判断数值 0~
 * @param {Number} val number
 */
export function isNumber (val) {
  return !isNaN(parseFloat(val))
}

/**
 * 处理请求到的金额
 * @param {Number} val number
 */
export function getAmount (val) {
  return isNumber(val) ? val / 100 : null
}

/**
 * 处理提交金额
 * @param {Number} val number
 */
export function setAmount (val) {
  return isNumber(val) ? val * 100 : null
}

/**
 * 处理请求到的百分比
 * @param {Number} val number
 */
export function getRatio (val, str = '%') {
  return isNumber(val) ? val / 100 + str : null
}

/**
 * 处理提交百分比
 * @param {Number} val number
 */
export function setRatio (val) {
  return isNumber(val) ? val * 100 : null
}

/**
 * 判断年龄范围是否重复 0~5 || 6-7
 * @param {Number} val number
 */
export function isRange (now, old) {
  const startRange = now.startAge >= old.startAge && now.startAge <= old.endAge
  const endRange = now.endAge >= old.startAge && now.endAge <= old.endAge

  return startRange || endRange
}

/**
 * 设置千分位
 * @param {*} n 数字
 */
 export const digitNum = (n) => {
  let tempN = ''
  if (isNumber(n)) {
    const splitN = Number(n).toFixed(2).split('.')
    tempN = splitN[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,') + (splitN[1] ? ('.' + splitN[1]) : '')
  }
  return tempN
}

/**
 * 取消千分位
 * @param {*} n 数字
 */
export const removeDigitNum = (n) => {
  return typeof n === 'string' ? Number(n.replace(/(,)/g, '')) : (isNumber(n) ? n : '')
}

/**
 * 判断数值是否在区间内
 * @param {Number} val number
 * @param {Number} min number
 * @param {Number} max number
 */
 export function isInRange (val, min, max) {
  if (val && val && max) {
    return Math.min(val, max) === Math.max(val, min)
  } else {
    return false
  }
}

/**
 * 处理时间
 * @param {Number} val number
 * @param {Number} min number
 * @param {Number} max number
 */
export function getTime (date) {
  return Math.floor(new Date(date).getTime() * 1000)
}
export function setTime (date) {
  return Math.floor(new Date(date).getTime() / 1000)
}

/**
 * 设置时间（年月日）
 * @param {*} t
 * @param {*} s
 * @returns string
 */
const setDateType = (t, s = '-') => {
  if (!t) return '-'
  const a = new Date(t)
  return a.getFullYear() + s + (a.getMonth() > 8 ? '' : '0') + (a.getMonth() + 1) + s + (a.getDate() > 9 ? '' : '0') + a.getDate()
}

/**
 * 设置时分秒
 * @param {*} t 时间（毫秒）
 * @param {*} str （分割字符）
 * @returns string
 */
const setDateSecond = (t, str = ':') => {
  if (!t) return '-'

  t = new Date(t)

  const h = t.getHours()
  const m = t.getMinutes()
  const s = t.getSeconds()

  return (h < 10 ? '0' : '') + h + str + (m < 10 ? '0' : '') + m + str + (s < 10 ? '0' : '') + s
}

/**
 * 设置开始时间
 * @param {Date} 时间
 * @returns Date
 */
export function setStartDate (t) {
  if (!t) return '-'
  const newDate = new Date(setDateType(t, '/')).getTime()
  return setDateType(newDate) + ' ' + setDateSecond(newDate)
}

/**
 * 设置结束时间
 * @param {Date} 时间
 * @returns Date
 */
export function setEndDate (t) {
  if (!t) return '-'
  const dayTime = 24 * 60 * 60 * 1000 - 1
  const newDate = new Date(setDateType(t, '/')).getTime() + dayTime
  return setDateType(newDate) + ' ' + setDateSecond(newDate)
}

/**
 * 保留小数
 */
export const precisionNum = (n, p = 2) => isNumber(n) ? Number(n).toFixed(p) : 0
